import React from 'react'
import { CompactTable } from '@table-library/react-table-library/compact'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import _ from 'lodash'

const UserListByTagsTable = ({
  columns = [],
  data = []
}) => {

  // needs id as a prop
  data = data.map(ele => { ele.id = ele._id; return ele })

  const tableData = {
    nodes: data,
  }

  const tableTheme = useTheme([
    getTheme(),
    {
      Table: `
        --data-table-library_grid-template-columns: 
          minmax(4rem, 1fr)    // Sr No.
          minmax(18rem, 1fr)   // Name
          minmax(20rem, 1fr)   // Email/Phone
          minmax(20rem, 1fr)   // User Tags
          minmax(13rem, 1fr)   // Credits
          minmax(11rem, 1fr)   // Recur
          minmax(16rem, 1fr)   // Low Credit Notification Threshold
          minmax(8rem, 1fr)    // Role
          minmax(22rem, 1fr)   // User Source
          minmax(10rem, 1fr)   // Channel Source
          minmax(13rem, 1fr)   // Channel Source Campaign
          minmax(16rem, 1fr)   // Channel Source Query
          minmax(10rem, 1fr)   // Affiliate
          minmax(10rem, 1fr)   // Sign Up IP
          minmax(10rem, 1fr)   // Sign Up Country
          minmax(12rem, 1fr)   // Activated On
          minmax(12rem, 1fr)   // Created On
          minmax(14rem, 1fr)   // Account Delete Reason
          minmax(12rem, 1fr);  // User Id
        grid-template-rows: max-content;
      `,
      HeaderCell: `
        height: fit-content;
        border-top: 1px solid #dee2e6;
        border-left: 1px solid #dee2e6;
      `,
      Row: `
        font-size: 14px;        
        .td{
          border-bottom: 1px solid #dee2e6;
          border-left: 1px solid #dee2e6;
        }
          &:hover .td {
          background-color:rgba(0, 0, 0, 0.075);
          font-weight: bold;
        }
          &:hover .tags-co-name-format {
          font-weight: bold !important;
        }
          &:hover .tags-user-list-table-icon-wrapper {
          opacity: 1 !important;
          visibility: visible !important;
        }
      `,
      BaseCell: `
        .td {
          border-left: 1px solid #dee2e6;
        }
      `,
    },
  ])

  if (_.isEmpty(data)) {
    return (
      <div className="tags-user-list-table-container">
        <div className="text-center p-5">
          <p className="fw-bold m-0">No Records Found</p>
        </div>
      </div>
    )
  }

  return (
    <div className="tags-user-list-table-container">
      <CompactTable
        className="tags-user-list-table-row"
        columns={columns}
        data={tableData}
        theme={tableTheme}
        layout={{ custom: true, horizontalScroll: true }}
      />
    </div>
  )
}

export default UserListByTagsTable
